import ModelType from '../ModelType';
import T from '../../../localization/LocalizationKeys';
import _ from 'lodash';
import { AggregationTranslation, TimeBucketTranslation } from '../../../services/constants';

export const AggregateModel = {
  path: 'aggregate',
  type: ModelType.OPTIONSV2,
  label: T.common.input.aggregate.title,
  options: _.map(AggregationTranslation, (text, value) => ({ text, value })),
  properties: {
    isClearable: false
  }
};

export const IntervalModel = {
  path: 'interval',
  type: ModelType.OPTIONSV2,
  label: T.common.input.timebucket.title,
  options: _.map(TimeBucketTranslation, (text, value) => ({ text, value })),
  properties: {
    isClearable: false
  }
};
